import React, {SyntheticEvent} from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconName, IconProp, IconPrefix } from "@fortawesome/fontawesome-svg-core";
import { faFacebookSquare, faTwitter } from '@fortawesome/free-brands-svg-icons';

export const IconsDictionaryByCategory: { [key: string]: RegExp } = {
  bookOpen: /Safety|Education|Charter|Educational|Pre(.|)K|School|Student|Teacher/i,
  tree: /Climate|Green|Renewable Energy/i,
  child: /Child|Minor|Childcare|Parenting/i,
  heartbeat: /Health|Healthcare|Addiction|COVID(.|)19|Medicaid|Medicare|Mental|Opioid|Epidemic|Opioid Crisis|Prescrition|Drug/i,
  bus: /Transportation|Accessibility|Infrastructure/i,
  gavel: /Gun|Safety|Criminal|Justice Reform|Incarceration|Bail|Crime|Death|penalty|Legalizing|marijuana|Police|Policing|Prosecutorial|Discretion|Immunity|Conviction/i,
  home: /House|Home|Housing|Evictions|Homeless|Landlord|Tenant/i,
  mobile: /Technology|Broadband access|Online Learning|Regulation/i,
  moneyBill: /Economy|Diversity|Inclusion|Economic|Development|Fiscal|Trade|Job|Jobs|Monetary|Business|Social Security|Taxes|Worker/i,
  passport: /Immigration|Border Security|Refugee|Asylum/i,
  flag: /Foreign|Relation|Indo-Pacific|China|Europe|Israel|Palestine|Middle(.|)East|Nuclear|Proliferation|Russia/i,
  microphone: /^About.*|^Why.*/i,
  shield: /^ *Security *$|Cybersecurity|Data Privacy|Defense|National Security|War on Terror/i,
  handshake: /Civil|LGB[a-z]+|Racial Justice|Redistricting|Religious|Reproductive|Voting|Women|Rights/i,
  comment: /Other|Miscellaneous|/i,
};
const defaultIcon: IconName = 'comment';
const brandIconTypes = ['twitter', 'facebook', 'facebook-square', 'instagram', 'linkedin'];
const uiIcons = [
  'photo-video', 'scroll', 'chevron-down', 'check-circle', 'times-circle', 'caret-up', 'caret-down',
  'close', 'bars', 'times', 'bullhorn', 'redo',
  'circle', 'volume-high', 'volume-xmark', 'play', 'pause',
  'fly', 'circle-play', 'copy', 'share', 'expand', 'compress', 'chevron-left', 'chevron-right', 'envelope',
  'arrow-up-right-from-square',
];
const predefinedIconTypes = ['filter', 'search'].concat(brandIconTypes).concat(uiIcons);

export function getIconByType(topicType?: string): string {
  let selectedIcon = null;

  if (!topicType) return defaultIcon;

  for (const category in IconsDictionaryByCategory)
    if (topicType === category || topicType.toString().trim().match(IconsDictionaryByCategory[category]) !== null) {
      selectedIcon = category as IconName;
      break;
    }

  return selectedIcon || defaultIcon;
}

export default function Icons(props: { iconType: string; prefix?: string; iconClass?: string; handleClick?: (event?: SyntheticEvent) => void }) {
  const { iconType, iconClass, handleClick = () => { } } = props;
  let currentIconType = iconType;
  let prefix = props.prefix;

  if (iconType && !predefinedIconTypes.includes(iconType))
    currentIconType = getIconByType(iconType);

  if (iconType && brandIconTypes.includes(iconType))
    prefix = 'fab';

  if (iconType === '' || (!iconType || !currentIconType) && !predefinedIconTypes.includes(iconType))
    currentIconType = defaultIcon;

  if (currentIconType === 'bookOpen') currentIconType = 'book-open'
  if (currentIconType === 'moneyBill') currentIconType = 'money-bill-alt'
  if (currentIconType === 'shield') currentIconType = 'shield-alt'
  if (currentIconType === 'facebook') currentIconType = 'facebook-square'

  return <FontAwesomeIcon
    icon={[prefix as IconPrefix, currentIconType as IconName]}
    className={iconClass}
    onClick={(event) => handleClick(event)}
  />
}
